import React from 'react';

const Hr = () => {
  return <hr className="my-2 border-textColorPrimary dark:border-white " />;
};

export default Hr;
